const MI_WOM_USER_KEY = 'miWomUser';
const TOKEN_KEY = 'tkn';
const REFRESH_TOKEN_KEY = 'refreshToken';

const SSO_TOKEN_KEY = 'tkn_sso';

const isBrowser = () => typeof window !== 'undefined';

const getStorageUser = () =>
  JSON.parse(isBrowser() ? window.localStorage.getItem(MI_WOM_USER_KEY) : null);

/* COMPLETE STORAGE: on request only */
/* user is automatically set on using useUser hook */
const setStorageUser = rawUser => {
  if (!isBrowser()) return false;
  const user = {
    user: rawUser.user,
    plan: rawUser.plan,
    paymentUrl: rawUser.paymentURL,
    billingCicle: rawUser.billingCycle,
  };

  window.localStorage.setItem(TOKEN_KEY, rawUser.token);
  window.localStorage.setItem(MI_WOM_USER_KEY, JSON.stringify(user));
  window.localStorage.setItem(REFRESH_TOKEN_KEY, rawUser.refreshToken);
  return user;
};

const setStorageSSOToken = accessToken => {
  if (!isBrowser()) return false;
  window.localStorage.setItem(SSO_TOKEN_KEY, accessToken);
  return { accessToken };
};

const logoutUser = () => {
  if (!isBrowser()) return false;
  window.localStorage.removeItem(MI_WOM_USER_KEY);
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  window.localStorage.removeItem(SSO_TOKEN_KEY);
  return true;
};

const ssoRedirect = () => {
  if (isBrowser()) window.location.replace(`${process.env.SSO_URL}login/movil`);
};

export {
  getStorageUser,
  setStorageUser,
  setStorageSSOToken,
  logoutUser,
  ssoRedirect,
};
